import ActiveSinceComponent from './active_since';
import CardWrapper from '../wrapper/card';
import ClientDetailComponent from './client_detail';
import ClientTeamComponent from './client_team';
import DueTasksComponent from './due_task';
import EditDeal from '../deal/edit';
import { grey } from '@mui/material/colors';
import RecentFilesComponent from './recent_files';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';

const AdminClientDashboard = () => {
    const { selectedClient, flags } = useSelector((state: RootState) => state.client);

    if (flags.isEditClient) {
        return <EditDeal />;
    }
    return (
        <CardWrapper minHeight="80vh" overflow="auto">
            <Box display="flex" alignItems="start" gap="10px">
                {selectedClient?.company_type === 'company' && <ActiveSinceComponent />}
                <Box flex={selectedClient?.company_type === 'company' ? 4 : 1} minHeight="250px">
                    <ClientTeamComponent />
                </Box>
                <ClientDetailComponent />
            </Box>
            <Box display="flex" gap="10px" my={2}>
                <DueTasksComponent />
                <RecentFilesComponent />
            </Box>
            {selectedClient?.company_type === 'company' && <CardWrapper minHeight="200px">
                <Typography color="textSecondary" variant="h6" mb={1}>Transaction Details</Typography>
                <Box border={`1px dashed ${grey[300]}`} height="15vh" display="flex" alignItems="center" justifyContent="center" borderRadius={1}>
                    <Typography variant="body2">No transaction</Typography>
                </Box>
            </CardWrapper>}
            {/* <AddContactModal open={} /> */}
        </CardWrapper>
    );
};

export default AdminClientDashboard;